import { faGem } from "@jewlr/pro-light-svg-icons/faGem"
import { faMedal } from "@jewlr/pro-light-svg-icons/faMedal"
import { faRotateLeft } from "@jewlr/pro-light-svg-icons/faRotateLeft"
import { faTruckBolt } from "@jewlr/pro-light-svg-icons/faTruckBolt"

import Divider from "components/ui/divider"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { IS_NA, IS_GE_CHECKOUT, jewlr_t } from "helpers/application"

const Perks = () => {
  const is_na = IS_NA()
  const is_ge_checkout = IS_GE_CHECKOUT()

  return (
    <div className="contained tablet:px-0 mb-40">
      <Divider className="bg-grey-20 mb-40 mt-20" />
      <div className="tablet:grid-cols-[repeat(4,100px)] tablet:gap-32 desktop:gap-56 grid grid-cols-[repeat(4,54px)] justify-center gap-16">
        <div className="text-center">
          <FontAwesomeIcon
            className="text-26 tablet:text-54 pb-8 text-black"
            icon={faTruckBolt}
          />
          <p className="text-10 tablet:text-14 leading-11 tablet:leading-17 mx-auto font-medium">
            FREE {jewlr_t("terms.Shipping")}
          </p>
        </div>
        <div className="text-center">
          <FontAwesomeIcon
            className="text-26 tablet:text-54 pb-8 text-black"
            icon={faMedal}
          />
          <p className="text-10 tablet:text-14 leading-11 tablet:leading-17 tablet:px-8 mx-auto font-medium">
            One-Year Warranty
          </p>
        </div>
        <div className="text-center">
          <FontAwesomeIcon
            className="text-26 tablet:text-54 pb-8 text-black"
            icon={faRotateLeft}
          />
          <p className="text-10 tablet:text-14 leading-11 tablet:leading-17 tablet:px-16 mx-auto font-medium">
            {is_ge_checkout ? "30" : "99"}-Day Returns
          </p>
        </div>
        <div className="text-center">
          <FontAwesomeIcon
            className="text-26 tablet:text-54 pb-8 text-black"
            icon={faGem}
          />
          <p className="text-10 tablet:text-14 leading-11 tablet:leading-17 tablet:px-5 mx-auto font-medium">
            Made in {is_na ? "USA & Canada" : "North America"}
          </p>
        </div>
      </div>
    </div>
  )
}

export default Perks
